import {IRoutableModule} from '../../router/routing.infra';
import {HistoryConsoleView} from './history-console.view';
import {historyConsoleRouteLoader} from './history-console.loader';

import './style.scss';

export default {
    loader: historyConsoleRouteLoader,
    Component: HistoryConsoleView,
    storeAs: 'historyConsoleStore'
} as IRoutableModule;
